import { Plus } from 'lucide-react';

import { GetAllSitesExtended } from '@/api/fe-api/view/queries/get-all-sites-extended';
import { Link } from '@/components/ui/link';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

import { SiteListItem } from './site-list-item';

export function SiteList() {
  const allSites = GetAllSitesExtended.useQuery();
  const featureFlag = useFeatureFlag();

  return (
    <div className="w-full" data-testid="asset list">
      <h2 className="mb-4 text-2xl font-semibold">List of Assets</h2>
      <ul className="flex flex-col gap-2">
        {allSites.isLoading ? (
          <span className="rounded border p-5 text-zinc-500">
            {'Loading assets\u22EF'}
          </span>
        ) : allSites.data && allSites.data.length > 0 ? (
          allSites.data.map((site) => (
            <SiteListItem key={site.id} site={site} />
          ))
        ) : (
          <span className="rounded border p-10 text-center text-zinc-500">
            Looks like there are no assets yet!
          </span>
        )}
      </ul>
      {featureFlag('recordsCreate') ? (
        <Link to="/new-asset">
          <div className="mt-3 flex w-full justify-center gap-2 border border-dashed px-4 py-10 text-zinc-400 hover:bg-zinc-950/5">
            <Plus className="size-4" />
            Add New Asset
          </div>
        </Link>
      ) : null}
    </div>
  );
}
